// extracted by mini-css-extract-plugin
export default {"badgeContainer":"direct-path-badge_badgeContainer__UsXcB","badgeIcon":"direct-path-badge_badgeIcon__4Y6df","badgeText":"direct-path-badge_badgeText__9EVu2"};